import { useMemo } from 'react';

type Role = string;

interface UseRolesReturn {
  isSiteAdmin: boolean;
  isOrgAdmin: boolean;
  isCustomer: boolean;
  isSupport: boolean;
  isAdmin: boolean;
  hasRole: (role: Role) => boolean;
  hasAnyRole: (roles: Role[]) => boolean;
  groups: string[];
}

export const useRoles = (): UseRolesReturn => {
  const groups = useMemo(() => {
    const groupsStr = sessionStorage.getItem('groups');
    if (!groupsStr) return [];
    try {
      return JSON.parse(groupsStr) as string[];
    } catch {
      return [];
    }
  }, []);

  const isSiteAdmin = groups.includes('site-admin');
  const isOrgAdmin = groups.includes('org-admin');
  const isCustomer = groups.includes('customer');
  const isSupport = groups.includes('support');
  const isAdmin = isSiteAdmin || isOrgAdmin;

  const hasRole = (role: Role) => groups.includes(role);
  const hasAnyRole = (roles: Role[]) => roles.some(role => groups.includes(role));

  return { isSiteAdmin, isOrgAdmin, isCustomer, isSupport, isAdmin, hasRole, hasAnyRole, groups };
};
